import ContactListBlock from './ContactListBlock';

export default ContactListBlock;
